import React from 'react';
import { marked } from 'marked';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

const removeAnnotations = (text) => {
  if (typeof text !== 'string') {
    return String(text || '');
  }
  // Remove anything between 【 and 】
  const pattern = /【[^】]*】/g;
  return text.replace(pattern, '');
};

const parseMarkdown = (markdownText) => {
  if (markdownText === null || markdownText === undefined) {
    return '';
  }
  
  // Convert to string if not already a string
  const textToProcess = typeof markdownText === 'string' 
    ? markdownText 
    : String(markdownText);
    
  const cleanedText = removeAnnotations(textToProcess);
  const html = marked(cleanedText);
  const cleanHtml = DOMPurify.sanitize(html);
  return cleanHtml;
};

export const RenderMarkdown = ({ markdown }) => {
  const html = parseMarkdown(markdown);
  return <>{parse(html)}</>;
};
